/**
 * Supported STT providers when generating an autoscript
 * When adding a new STT Provider, please:
 * [1] Add to the STTProvider enum
 * [2] Update STT_AWS_REGION_MAPPING with a new mapping of AWS regions to the regions the provider has servers in
 *    Tip: If the provider does not offer STT in a particular AWS geographic region, set it to `undefined` - don't
 *    use a fall back to a different region.
 * [3] Update STT_PROVIDER_LABELS so the option appears in ftr-web
 */
export var STTProvider;
(function (STTProvider) {
    /**
     * IBM Watson Speech-To-Text
     *
     * https://www.ibm.com/watson/services/speech-to-text/
     */
    STTProvider["IBMWatson"] = "ibm watson";
    /**
     * Microsoft's Cognitive Service Speech To Text
     *
     * https://docs.microsoft.com/en-gb/azure/cognitive-services/speech-service/batch-transcription
     */
    STTProvider["CognitiveSpeech"] = "microsoft cognitive services speech to text";
    /**
     * Amazon Transcribe
     *
     * https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/TranscribeService.html
     */
    STTProvider["AmazonTranscribe"] = "amazon transcribe";
    /**
     * Google Cloud Speech To Text
     *
     * https://cloud.google.com/speech-to-text
     */
    STTProvider["GoogleCloudSpeechToText"] = "google cloud speech to text";
})(STTProvider || (STTProvider = {}));
/**
 * Adding an entry here allows the STT provider to be selected from the Global Admin dropdown menu
 */
export const STT_PROVIDER_LABELS = {
    [STTProvider.CognitiveSpeech]: 'Microsoft Azure Cognitive Speech',
    [STTProvider.AmazonTranscribe]: 'Amazon Transcribe',
};
export function isSttProvider(sttProvider) {
    return Object.values(STTProvider).includes(sttProvider);
}
